import { isString } from '../utils/type-check';
/**
 * @param {string|string[]} arrayOfString
 * @returns {string[]}
 */
export default function normalizeArrayOfString(arrayOfString) {
  if (arrayOfString === undefined) {
    return;
  } else if (isString(arrayOfString)) {
    return [arrayOfString];
  } else if (Array.isArray(arrayOfString)) {
    return arrayOfString.filter(isString);
  } else {
    return [];
  }
}